import { MouseEventHandler } from "react";
import { aigcBGMStore } from "../store/bgm-list";
import { SVGPureIcon } from "@/ui";
import { observer } from "mobx-react-lite";

type PropsType = {
  item: any;
  modelValue: string;
  onClick: MouseEventHandler<HTMLDivElement>
}

const SingleSelect = (props: PropsType) => {
  if (!props.item) {
    return
  }
  return (
    <div
      className="mouse-active-translate transition-colors duration-300 h-48px flex transition-opacity duration-300 p-4px cursor-pointer border-box rounded-10px bg-white w-full cursor-pointer hover:opacity-80 flex text-14px items-center pr-20px"
      style={{
        aspectRatio: '288 / 48'
      }}
      onClick={props.onClick}
    >

      <div onClick={(e) => { e.nativeEvent.stopImmediatePropagation(); e.stopPropagation(); aigcBGMStore.onPlay(props.item) }}
        className="group overflow-hidden relative mr-8px rounded-8px h-full aspect-square">
        <img className=" cover" src={props.item?.cover || props.item?.icon || 'https://p4.ssl.qhimg.com/t110b9a93010bc287950d9cb1d8.jpg'} />
        {
          aigcBGMStore.playingID === props.item.id ?
            <SVGPureIcon
              className=" absolute m-auto inset-0 flex z-10" color='#fff' size={14} name='pause'
              style={{ filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.50))' }}
            /> : props.item.voice_url &&
            <SVGPureIcon
              className="group-hover:block absolute m-auto inset-0 hidden group-hover:flex z-10" color='#fff' size={14} name='play'
              style={{ filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.50))' }}
            />
        }
      </div>

      {props.item?.title || props.item?.model_title}
      {
        aigcBGMStore.playingID === props.item.id &&
        <img src='https://p2.ssl.qhimg.com/t110b9a930164d61ae46ee69f7c.gif' className="ml-auto w-16px h-16px" />
      }
    </div>
  )
}

export default observer(SingleSelect) 